export default "__VITE_ASSET__CfiG8ki6__"